module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-02.e8abd578.jpg";